/**
 * AppSync conflict detection soft-deletes records by setting `_deleted`.
 * That field is sync metadata, so it is not on the generated model types.
 */
export const isSoftDeleted = (item: object): boolean =>
    Boolean((item as { _deleted?: boolean | null })._deleted)
